/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { combineGoals, groupGoalsBySubcategory } from 'linced-app/utils/topics';
import topicSteps from '@linc-technologies/linced-common/utils/topic-steps';

export default class DetailsController extends Controller {
  // Services
  @service
  store;

  @service
  strings;

  @tracked
  selectedGoal = null;
  @tracked
  steps = [];

  @tracked
  goalDialogOpen;

  @tracked
  selectedGoalStates;

  @computed('model.currentGoal.goal.linkedGoals.content.[]')
  get sortedCoreGoals() {
    let linkedGoals = this.get('model.currentGoal.goal.linkedGoals') || [];
    return groupGoalsBySubcategory(linkedGoals);
  }

  @computed('model.currentGoal.goal.priorLinkedGoals.content.[]')
  get sortedPriorGoals() {
    let linkedGoals = this.get('model.currentGoal.goal.priorLinkedGoals') || [];
    return groupGoalsBySubcategory(linkedGoals);
  }

  @computed('model.currentGoal.goal.futureLinkedGoals.content.[]')
  get sortedFutureGoals() {
    let linkedGoals =
      this.get('model.currentGoal.goal.futureLinkedGoals') || [];
    return groupGoalsBySubcategory(linkedGoals);
  }

  @computed('sortedCoreGoals', 'sortedPriorGoals', 'sortedFutureGoals')
  get combinedGoals() {
    return combineGoals(
      this.sortedCoreGoals,
      this.sortedPriorGoals,
      this.sortedFutureGoals,
    );
  }

  @action
  noOp() {}

  @action
  openGoalDialog(goal, event) {
    event.preventDefault();
    this.selectedGoal = goal;
    // Although we already have the states, providing a fresh query allows the group-goal-setter to refresh
    // just the states for this goal, rather than having to refresh the states for ALL goals in the subject
    // every time a goal state is changed.  Closing the dialog will perform the full reload.
    this.selectedGoalStates = this.store.query('goals/state', {
      groupId: this.model.group.id,
      goalId: goal.id,
      current: true,
    });
    this.goalDialogOpen = true;
  }

  @action
  closeGoalDialog() {
    this.goalDialogOpen = false;
    this.model.currentGoal.states.update();
  }

  @action
  refreshStates() {
    return this.model.currentGoal.states.update();
  }

  init() {
    super.init(...arguments);

    this.steps = topicSteps;
  }
}
